function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo } from 'react';
import { ReactNodeIsTabItem, TabItem } from './TabItem';
import { TabsImpl } from './TabsImpl';
import { TabsContextProvider, useTabs } from './../hooks';
export function Tabs(props) {
  var activeId = props.activeId,
      children = props.children,
      controlled = props.controlled,
      onChange = props.onChange,
      _props$lazy = props.lazy,
      lazy = _props$lazy === void 0 ? false : _props$lazy,
      onTabClick = props.onTabClick,
      beforeActiveChange = props.beforeActiveChange,
      onEdit = props.onEdit,
      _props$tabPosition = props.tabPosition,
      tabPosition = _props$tabPosition === void 0 ? 'top' : _props$tabPosition,
      extra = _objectWithoutProperties(props, ["activeId", "children", "controlled", "onChange", "lazy", "onTabClick", "beforeActiveChange", "onEdit", "tabPosition"]);

  var preparedChildren = React.Children.toArray(children).filter(ReactNodeIsTabItem);
  var defaultActive = useMemo(function () {
    var _a;

    if (activeId == null) {
      var _iterator = _createForOfIteratorHelper(preparedChildren),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (((_a = item === null || item === void 0 ? void 0 : item.props) === null || _a === void 0 ? void 0 : _a.id) != null) {
            return item.props.id;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return;
    }

    return activeId;
  }, [activeId, children]);
  var tabs = useTabs({
    active: activeId,
    defaultActive: defaultActive,
    controlled: controlled,
    lazy: lazy,
    tabPosition: tabPosition,
    onActiveChange: onChange,
    shouldChangeActive: beforeActiveChange,
    onCloseItem: function onCloseItem(id) {
      return void (onEdit === null || onEdit === void 0 ? void 0 : onEdit('close', id));
    },
    onAddItem: function onAddItem() {
      return void (onEdit === null || onEdit === void 0 ? void 0 : onEdit('add'));
    }
  });
  return React.createElement(TabsContextProvider, {
    value: tabs
  }, React.createElement(TabsImpl, Object.assign({
    onTabClick: onTabClick,
    tabPosition: tabPosition
  }, extra), preparedChildren));
}
Tabs.Item = TabItem;